<h5 class="" translate>Edit fields</h5>
<hr />
@if (!isLoaded) {
    <sb-loader></sb-loader>
} @else {
    @if (fields.length) {
        <div id="formContainer">
            <form
                #ticketForm="ngForm"
                class="form"
                id="editFieldsForm"
                [ngClass]="{ 'form-submitted': formService.isSubmitted }">
                @for (formField of fields; track formField) {
                    <sb-form-field
                        [formField]="formField"
                        [isElementNameShown]="true"
                        [formType]="formTypesEnum.inboxEditFields"
                        [isShowHiddenFields]="true">
                    </sb-form-field>
                }
            </form>
            <div class="buttons-row">
                <button type="button" class="btn btn-default" (click)="closePanel()">
                    {{ hasEditableFields ? ('Cancel' | translate) : ('Close' | translate) }}
                </button>
                @if (hasEditableFields) {
                    <button type="button" class="btn btn-primary ms-2" (click)="save()" [disabled]="isSaving" translate>
                        Save
                    </button>
                }
            </div>
        </div>
    } @else {
        <p translate>This ticket has no fields</p>
    }
}
